//Controllers
import ApiController from './ApiController';
//Modelos
import Clientes from '../models/relatorios/Clientes';
import Empresas from '../models/relatorios/Empresas';
import AvaliacaoData from '../models/relatorios/AvaliacaoData';

/**
 * Retorno da consulta do relatório de clientes
 * @typedef RelatorioClientes
 * @property {Boolean} sucesso Indica se a requisição foi executada
 * @property {Array<String>} erros Mensagens de erro em caso de falha
 * @property {Clientes} dados Em caso de sucesso contém os tipos retornados
 */

/**
 * Retorno da consulta do relatório de avaliacoes por data
 * @typedef RelatorioAvaliacoesData
 * @property {Boolean} sucesso Indica se a requisição foi executada
 * @property {Array<String>} erros Mensagens de erro em caso de falha
 * @property {AvaliacaoData} dados Em caso de sucesso contém os tipos retornados
 */

/**
 * Retorno da consulta do relatório de empresas
 * @typedef RelatorioEmpresas
 * @property {Boolean} sucesso Indica se a requisição foi executada
 * @property {Array<String>} erros Mensagens de erro em caso de falha
 * @property {Empresas} dados Em caso de sucesso contém os tipos retornados
 */

/**
 * Controller para obter os dados de relatórios para os dashboards do sistema
 */
class RelatorioController {

    constructor() {
        this.apiController = new ApiController();
    }

    /**
     * Consulta o relatório de clientes
     * @return {Promise<RelatorioClientes>} Retorna os dados obtidos
     */
    async clientes() {
        try {
            //Envia requisição para o servidor e captura os dados de resposta
            const { data: dados } = await this.apiController.get('/relatorio/clientes');
            //Marca que houve retorno com sucesso
            const result = {
                sucesso: true,
                dados: Clientes.clone(dados)
            };
            return result;
        }catch (error) {
            console.error('Erro em RelatorioController.avaliacoes:', error);
            return {
                sucesso: false,
                erros: error.response?.data || 'Erro inesperado ao buscar avaliações.'
            }
        };
        // } catch (error) {
        //     //Captura o erro e retorna para a aplicação
        //     return { sucesso: false, erros: error.response.data };
        // }
    }

    /**
     * Consulta o relatório de avaliações por dia do último mês
     * @return {Promise<RelatorioAvaliacoesData>} Retorna os dados obtidos
     */
    async avaliacoes() {
        try {
            //Envia requisição para o servidor e captura os dados de resposta
            const { data: dados } = await this.apiController.get('/relatorio/avaliacoes');
            //Marca que houve retorno com sucesso
            const result = {
                sucesso: true,
                dados: AvaliacaoData.clone(dados)
            };
            return result;
        }catch (error) {
            console.error('Erro em RelatorioController.avaliacoes:', error);
            return {
                sucesso: false,
                erros: error.response?.data || 'Erro inesperado ao buscar avaliações.'
            }
        };
        // } catch (error) {
        //     //Captura o erro e retorna para a aplicação
        //     return { sucesso: false, erros: error.response.data };
        // }
    }

    /**
     * Consulta o relatório de empresas
     * @return {Promise<RelatorioAvaliacoesData>} Retorna os dados obtidos
     */
    async empresas() {
        try {
            //Envia requisição para o servidor e captura os dados de resposta
            const { data: dados } = await this.apiController.get('/relatorio/empresas');
            //Marca que houve retorno com sucesso
            const result = {
                sucesso: true,
                dados: Empresas.clone(dados)
            };
            return result;
            }catch (error) {
                console.error('Erro em RelatorioController.avaliacoes:', error);
                return {
                    sucesso: false,
                    erros: error.response?.data || 'Erro inesperado ao buscar avaliações.'
                }
            };
        // } catch (error) {
        //     //Captura o erro e retorna para a aplicação
        //     return { sucesso: false, erros: error.response.data };
        // }
    }
}

export default RelatorioController;